import Link from "../../common/link";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const Page: React.FC<{
  pageTitle: string;
  breadcrumbs: Link[];
  children: any;
}> = ({ pageTitle, breadcrumbs, children }) => {
  const navigate = useNavigate();

  return (
    <>
      {/* <!-- Main Content --> */}
      <main className="main">
        <div className="main-content">
          {/* <!-- Page Header --> */}
          <div className="page-header">
            <h1 className="page-title">{pageTitle}</h1>
            <nav className="breadcrumb">
              {/* <a href="index.html" className="breadcrumb-item">
                Work Order Direct
              </a> */}

              <div
                className="navlink breadcrumb-item"
                onClick={() => navigate("/work")}
              >
                Work Order Direct
              </div>

              {breadcrumbs.map((link: Link, index: number) => (
                <span
                  key={link.linkName}
                  className={
                    "breadcrumb-item" +
                    (index === breadcrumbs.length - 1 ? " active" : " navlink")
                  }
                  onClick={() => navigate(link.linkUlr)}
                >
                  {link.linkName}
                </span>
              ))}
            </nav>
          </div>
          {children}
        </div>
        <Footer />
      </main>

      {/* <!-- Back to Top --> */}
      <a href="# " className="back-to-top">
        <i className="bi bi-arrow-up"></i>
      </a>
    </>
  );
};

export default Page;
